

export const getFields = (schema, fieldType) => schema?.filter(f => f?.type === fieldType)
export const getFieldNames = (schema) => schema?.map(f => f.name) 